import { WorkFlowStep } from './workflow.model';
import { AssigneeType } from '../../../common/models/assignee.model';

export const workflowConfigurationListDummyData = [
  {
    id: 1,
    name: 'Payment Request',
    icon: {
      id: 1,
      mime_type: 'image/png',
      name: 'icon.png',
      order: 1,
      url: 'https://storage.googleapis.com/dev-api-bucket-19e9c43733cf38/1/icon.png',
    },
    category: {
      id: 1,
      name: 'Finance',
    },
    sla: 168,
    step_templates_count: 3,
    kind: 'built_in' as const,
    requests_count: 0,
  },
  {
    id: 2,
    name: 'Comprehensive Project Management Workflow for Enhanced Collaboration and Efficiency',
    icon: null,
    category: {
      id: 1,
      name: 'In the world of technology, the designation Type 02 often refers to a specific model or version of a product that has undergone significant enhancements compared to its predecessor. This model is characterized by its advanced features, improved performance, and user-friendly interface, making it a popular choice among consumers. The Type 02 has been designed with the latest innovations in mind, ensuring that it meets the evolving needs of users in a fast-paced digital landscape.',
    },
    sla: 67,
    step_templates_count: 67,
    kind: 'built_in' as const,
    requests_count: 0,
  },
];

export const requestDetailsEmptyData = {
  id: 0,
  name: '',
  description: '',
  category: {
    id: 0,
    name: '',
  },
  current_position: 0,
  icon: {
    id: 0,
    name: '',
    mime_type: '',
    url: '',
    order: 0,
  },
  state: {
    value: '',
    label: '',
  },
  requirements: [],
  permissions: [],
  positions: [],
  sub_flow_templates_exists: false,
  is_triggable: false,
};

export const workflowShowDetailsDummyData = {
  data: {
    id: 1,
    name: 'Total Invoices Amount',
    description: 'Total Invoices Amount',
    category: {
      id: 1,
      name: 'Finance',
    },
    permissions: [],
    positions: [],
  },
};

export const workflowPermissionList = [
  {
    id: '1',
    name: 'test',
    image: {
      id: 212,
      name: 'Screenshot-from-2024-12-02-11-54-18.png',
      mime_type: 'image/png',
      url: 'https://storage.googleapis.com/dev-api-bucket-19e9c43733cf38/212/Screenshot-from-2024-12-02-11-54-18.png',
      order: 2,
    },
    category: {
      id: '1',
      name: 'test',
      owners: [
        {
          id: '2',
          name: 'tessst',
          email: 'testmail@yahoo.com',
          image: {
            id: 212,
            name: 'Screenshot-from-2024-12-02-11-54-18.png',
            mime_type: 'image/png',
            url: 'https://storage.googleapis.com/dev-api-bucket-19e9c43733cf38/212/Screenshot-from-2024-12-02-11-54-18.png',
            order: 2,
          },
        },
      ],
      owners_count: '22',
    },
    users_count: '22',
  },
];

export const workFlowStepsListDummyData = [
  {
    id: 1,
    name: '01- Project Mandate Exist',
    sla: 10,
    when: 'x > 10',
    assignee: [
      {
        type: 'user' as AssigneeType,
        data: {
          id: 1,
          name: 'Mathias Lebsack',
          image: {
            id: 3,
            name: 'images.png',
            mime_type: 'image/png',
            url: 'https://placehold.jp/3d4070/ffffff/150x150.png',
            order: 2,
          },
        },
      },
    ],
    escalation: {
      type: {
        value: 'send_email',
        label: 'Send Email',
      },
      stakeholder_type: 'user' as AssigneeType,
      stakeholder_data: {
        id: 1,
        name: 'Alaina Kautzer',
        image: null,
      },
    },
  },
  {
    id: 2,
    name: '02- Delivering Investment Structure',
    sla: 168,
    when: '',
    assignee: {
      type: 'user' as AssigneeType,
      data: {
        id: 1,
        name: 'Alaina Kautzer',
        image: null,
      },
    },
    escalation: {
      type: {
        value: 'send_email',
        label: 'Send Email',
      },
      stakeholder_type: 'group' as AssigneeType,
      stakeholder_data: {
        id: 1,
        name: 'DIB Group',
        image: null,
      },
    },
  },
  {
    id: 3,
    name: '03- Delivering Investment Structure',
    sla: 168,
    when: '',
    assignee: null,
    escalation: null,
  },
];

export const assigneeSelectDependencyEmpty = {
  api: '',
  selectedOption: {
    label: '',
    value: 0,
  },
  placeholder: '',
  filters: [],
  searchLabel: '',
  searchPlaceholder: '',
};

export const escalationSelectDependencyEmpty = {
  api: '',
  selectedOption: {
    label: '',
    value: 0,
  },
  placeholder: '',
  filters: [],
  searchLabel: '',
  searchPlaceholder: '',
};

export const workflowTableData = [
  {
    name: 'test',
    image: {
      id: 212,
      name: 'Screenshot-from-2024-12-02-11-54-18.png',
      mime_type: 'image/png',
      url: 'https://storage.googleapis.com/dev-api-bucket-19e9c43733cf38/212/Screenshot-from-2024-12-02-11-54-18.png',
      order: 2,
    },
    permissions: [
      {
        value: 'test',
        label: 'test',
      },
    ],
  },
];

export const workflowDetailsInitialData = {
  data: {
    id: 0,
    name: '',
    description: '',
    category: {
      id: 0,
      name: '',
    },
    permissions: [],
    positions: [],
    sub_flow_templates_exists: false,
    is_triggable: false,
  },
};

export const workflowOwner = {
  id: 28,
  identifier: 'ab11',
  name: 'Abdelrahman Mahfouz',
  first_name: 'Abdelrahman',
  last_name: 'Mahfouz',
  email: 'abdelrahman.mahfouz@areebgroup.com',
  phone: '+201146395000',
  image: {
    id: '169',
    name: 'Screenshot-from-2024-12-28-01-11-04.png',
    mime_type: 'image/png',
    url: 'https://storage.googleapis.com/dev-api-bucket-19e9c43733cf38/169/Screenshot-from-2024-12-28-01-11-04.png',
    order: 1,
  },
  state: {
    value: 'pending',
    label: 'Pending',
  },
};

export const workflowAssigneeListDummyData = {
  id: '1',
  type: 'user',
  name: 'User A',
  image: {
    id: 169,
    name: 'Screenshot-from-2024-12-28-01-11-04.png',
    mime_type: 'image/png',
    url: 'https://storage.googleapis.com/dev-api-bucket-19e9c43733cf38/169/Screenshot-from-2024-12-28-01-11-04.png',
    order: 1,
  },
  step_templates: [{ name: 'Step 1' }, { name: 'Step 2' }, { name: 'Step 3' }],
};

export const workflowStepDummyData: WorkFlowStep = {
  id: 2,
  name: '2.1 Compliance Review',
  sla: {
    value: 1,
    type: 'static',
    variable: {
      value: '1',
      label: 'test',
    },
  },
  when: null,
  assignees: [
    {
      type: 'department',
      preference: null,
      option: { label: '', value: '' },

      data: {
        id: 14,
        name: 'dep1',
        image: {
          id: 212,
          name: 'Screenshot-from-2024-12-02-11-54-18.png',
          mime_type: 'image/png',
          url: 'https://storage.googleapis.com/dev-api-bucket-19e9c43733cf38/212/Screenshot-from-2024-12-02-11-54-18.png',
          order: 2,
        },
      },
    },
    {
      type: 'group',
      preference: 2,
      option: { label: '', value: '' },
      data: {
        id: 1,
        name: 'front-end front-end front-end front-end front-end',
        image: {
          id: 164,
          name: 'angular.png',
          mime_type: 'image/png',
          url: 'https://storage.googleapis.com/dev-api-bucket-19e9c43733cf38/164/angular.png',
          order: 1,
        },
      },
    },
  ],
  escalation: {
    escalation_type: {
      value: 'send_email',
      label: 'Send Email',
    },
    type: {
      value: 'send_email',
      label: 'Send Email',
    },
    stakeholder_type: 'department',
    stakeholder_data: {
      id: 14,
      name: 'dep1',
      image: {
        id: 212,
        name: 'Screenshot-from-2024-12-02-11-54-18.png',
        mime_type: 'image/png',
        url: 'https://storage.googleapis.com/dev-api-bucket-19e9c43733cf38/212/Screenshot-from-2024-12-02-11-54-18.png',
        order: 2,
      },
    },
    variable: {
      value: '1',
      label: 'test',
    },
  },
  mode: 'edit',
  isExpanded: true,
  actions: [],
  step_actions: [
    {
      id: 1,
      type: {
        value: 'add_collaborators',
        label: 'Add Collaborators',
      },
      when: {
        value: 'triggered',
        label: 'Step triggered',
      },
      users: [
        {
          id: 244,
          identifier: '',
          name: 'user super-admin',
          email: 'account@areebgroup.com',
          image: null,
          last_accessed_at: '',
        },
        {
          id: 245,
          identifier: '',
          name: 'user super-admin',
          email: 'account@areebgroup.com',
          image: null,
          last_accessed_at: '',
        },
        {
          id: 246,
          identifier: '',
          name: 'user super-admin',
          email: 'account@areebgroup.com',
          image: null,
          last_accessed_at: '',
        },
        {
          id: 247,
          identifier: '',
          name: 'user super-admin',
          email: 'account@areebgroup.com',
          image: null,
          last_accessed_at: '',
        },
        {
          id: 248,
          identifier: '',
          name: 'user super-admin',
          email: 'account@areebgroup.com',
          image: null,
          last_accessed_at: '',
        },
      ],
    },
  ],
  position: 1,
};
